module.exports = __webpack_public_path__ + "img/disc-d.e3d7358f.png";